export const StringDictionary = {
  COMMENTS: 'comments',
  CURRENTUSER: 'currentUser',
  THEME: 'theme',
};
